import { User } from '@prisma/client'
import { Form } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/receptionist/common'
import { AppSessionType } from '~/features/appSession/common'
import { ProviderAccountAuthorization } from '~/features/formConfiguration/client/components/CustomInputs/ProviderAccountAuthorization'
import { SelectProviderAction } from '~/features/formConfiguration/client/components/CustomInputs/SelectProviderAction'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = {
  appSession: AppSessionType
  user: User
} & StepProps

export const StepGoogleCalendarAuthorizations: React.FC<Props> = ({
  appSession,
  user,
  ...props
}) => {
  const configuration = {
    appSessionId: appSession?.id,
    appId: appSession?.appId,
  }

  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>Which calendar should I use?</TitlePrimary>

        {/* <Typography.Text type="secondary" className="mb-10">
          I need to know which calendar to access to book appointments
        </Typography.Text> */}

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {instance => {
            const providerAccountId = instance.getFieldValue([
              'calendarServices',
              'providerAccountId',
            ])

            return (
              <Form.Item
                name={['googleCalendarSettings', 'permissionBook']}
                rules={[
                  {
                    validator: (_, value) =>
                      value?.[0]?.isCorrupted
                        ? Promise.reject()
                        : Promise.resolve(),
                    message: 'Authorization is not valid',
                  },
                  {
                    required: true,
                    message: 'You need to authorize to continue',
                  },
                ]}
              >
                <ProviderAccountAuthorization
                  providerAccountId={providerAccountId}
                  scope="https://www.googleapis.com/auth/calendar"
                  ui={{
                    title: 'Book Appointments',
                    iconAntd: 'GoogleOutlined',
                    description: 'Allow me to book events on your calendar',
                  }}
                />
              </Form.Item>
            )
          }}
        </Form.Item>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {options => {
            const providerAccountId = options.getFieldValue([
              'calendarServices',
              'providerAccountId',
            ])

            const permission = options.getFieldValue([
              'googleCalendarSettings',
              'permissionBook',
            ])

            if (!permission || !providerAccountId) {
              return <></>
            }

            return (
              <Form.Item
                name={['googleCalendarSettings', 'calendarId']}
                label="Pick your calendar"
                rules={[
                  {
                    required: true,
                    message: 'Please choose a calendar to continue',
                  },
                ]}
              >
                <SelectProviderAction
                  providerKey="googleCalendar"
                  providerItemsKey="calendars"
                  providerActionKey="findManyCalendars"
                  providerItemLabel="{item.name}"
                  providerAccountId={providerAccountId}
                  providerAccountScopeValues={permission}
                  providerItemValueKey="id"
                  formValuesConfiguration={configuration}
                />
              </Form.Item>
            )
          }}
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
